import _ from 'lodash';
import * as types from './types';

export const resetAppliedFilters = () => (dispatch) => {
  dispatch({
    type: types.SET_APPLIED_FILTERS,
    payload: { appliedFilters: {} },
  });
};

export const deleteAppliedFilter = (key) => (dispatch, getState) => {
  const previousAppliedFilters = getState().FiltersReducer.appliedFilters;
  const newFilters = _.omit(previousAppliedFilters, key);

  dispatch({
    type: types.SET_APPLIED_FILTERS,
    payload: { appliedFilters: newFilters },
  });
};

export const removeStateFromAppliedFilters = (state) => (
  dispatch,
  getState,
) => {
  const previousAppliedFilters = getState().FiltersReducer.appliedFilters;
  const previousAppliedStates = getState().FiltersReducer.appliedFilters.state;

  const radioValue = Object.keys(
    getState().FiltersReducer.appliedFilters.state,
  )[0];

  const updatedArray = previousAppliedStates[radioValue].filter(
    (el) => el !== state,
  );

  if (updatedArray.length) {
    dispatch({
      type: types.SET_APPLIED_FILTERS,
      payload: {
        currentPage: 0,
        appliedFilters: {
          ...previousAppliedFilters,
          state: { [radioValue]: updatedArray },
        },
      },
    });
  } else {
    dispatch(deleteAppliedFilter('state'));
  }
};

export const removeCityCountyZipFromAppliedFilters = (address) => (
  dispatch,
  getState,
) => {
  const previousAppliedFilters = getState().FiltersReducer.appliedFilters;
  const previousAppliedStates = getState().FiltersReducer.appliedFilters
    .cityCountyZip;

  const radioValue = Object.keys(
    getState().FiltersReducer.appliedFilters.cityCountyZip,
  )[0];

  const updatedArray = previousAppliedStates[radioValue].filter(
    (el) => el.formattedAddress !== address.formattedAddress,
  );

  if (updatedArray.length) {
    dispatch({
      type: types.SET_APPLIED_FILTERS,
      payload: {
        currentPage: 0,
        appliedFilters: {
          ...previousAppliedFilters,
          cityCountyZip: { [radioValue]: updatedArray },
        },
      },
    });
  } else {
    dispatch(deleteAppliedFilter('cityCountyZip'));
  }
};

export const removePropertyTypeFromAppliedFilters = (propertyType) => (
  dispatch,
  getState,
) => {
  const previousAppliedFilters = getState().FiltersReducer.appliedFilters;
  const previousAppliedPropertyTypes = getState().FiltersReducer.appliedFilters
    .propertyType;

  const radioValue = Object.keys(
    getState().FiltersReducer.appliedFilters.propertyType,
  )[0];

  const updatedArray = previousAppliedPropertyTypes[radioValue].filter(
    (el) => el !== propertyType,
  );

  if (updatedArray.length) {
    dispatch({
      type: types.SET_APPLIED_FILTERS,
      payload: {
        currentPage: 0,
        appliedFilters: {
          ...previousAppliedFilters,
          propertyType: { [radioValue]: updatedArray },
        },
      },
    });
  } else {
    dispatch(deleteAppliedFilter('propertyType'));
  }
};

export const removeTransactionTypeFromAppliedFilters = () => (dispatch) => {
  dispatch(deleteAppliedFilter('transactionType'));
};

export const removeNumberOfUnitsFromAppliedFilters = () => (dispatch) => {
  dispatch(deleteAppliedFilter('numberOfUnits'));
};

export const setAppliedFilters = (key, filter) => (dispatch, getState) => {
  const previousAppliedFilters = getState().FiltersReducer.appliedFilters;

  dispatch({
    type: types.SET_APPLIED_FILTERS,
    payload: {
      currentPage: 0,
      appliedFilters: { ...previousAppliedFilters, [key]: filter },
    },
  });
};

export const setFiltersFromView = (appliedFilters) => (dispatch) => {
  dispatch({
    type: types.SET_APPLIED_FILTERS,
    payload: {
      currentPage: 0,
      appliedFilters,
    },
  });
};
